<template>
  <div class="dropdown-container">
    <DropdownPrime
      v-model="selectedValue"
      :options="options"
      optionLabel="Glosa"
      optionValue="Id"
      placeholder="Colegio"
      :class="{ 'p-invalid': mostrarErrores && error }"
      v-tooltip="tooltipOpts"
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import ColegioService from '@/services/ColegioService';

function normId(v) {
  if (v === '' || v === undefined || v === null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export default {
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    tooltipOpts() {
      return {
        value: this.tooltip || '',
        position: 'bottom',
        disabled: !String(this.tooltip || '').trim(),
      };
    },
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValue = ref(normId(props.modelValue));

    const fetchOptions = async () => {
      try {
        const response = await ColegioService.get();
        options.value = response.data;
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValue.value);
    };

    onMounted(() => {
      fetchOptions();
    });

    watch(
      () => props.modelValue,
      (newValue) => {
        selectedValue.value = normId(newValue);
      }
    );

    return {
      options,
      selectedValue,
      emitSelection,
    };
  },
};
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>
